'use client';

import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { ButtonWithIcon } from '@/components/buttons/buttonWithIcon';
import { ByovSetupMethod } from './byovSetupMethod';
import { ByovSetupScriptPanel } from './byovSetupScriptPanel';
import { VaultOwnBucketCopyableAllAccountsPolicy } from './vaultOwnBucketCopyablePolicy';
import { VaultOwnBucketEditKeyPolicyButton } from './vaultOwnBucketEditKeyPolicyButton';
export const ByovInfrastructureRequirements = t0 => {
  const $ = _c(15);
  const {
    bucketName,
    region,
    section,
    accountId: t1
  } = t0;
  const accountId = t1 === undefined ? "" : t1;
  const [method, setMethod] = useState("console");
  const managementUrl = `https://s3.console.aws.amazon.com/s3/management/${encodeURIComponent(bucketName)}`;
  const bucketQuery = `region=${encodeURIComponent(region)}&bucketType=general`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "24px"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== method || $[2] !== section) {
    t3 = !section && <ByovSetupMethod method={method} onChange={setMethod} />;
    $[1] = method;
    $[2] = section;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== accountId || $[5] !== bucketName || $[6] !== bucketQuery || $[7] !== managementUrl || $[8] !== method || $[9] !== region || $[10] !== section) {
    t4 = !section && method === "script" ? <ByovSetupScriptPanel bucketName={bucketName} region={region} accountId={accountId} /> : <Stack sx={{
      gap: "24px"
    }}>{(!section || section === "lifecycle") && <Stack sx={{
        gap: "8px"
      }}>{!section && <Typography variant="h4">1. Create Lifecycle Rule in AWS</Typography>}<Typography variant="body1">1. Enter a rule name. Select{" "}<strong>Apply to all objects in the bucket</strong> and acknowledge the selection.</Typography><Typography variant="body1">2. Select{" "}<strong>Permanently delete noncurrent versions of objects</strong>. Enter 1 under{" "}<strong>Days after objects become noncurrent</strong>. Leave{" "}<strong>Number of newer versions to retain</strong> empty.</Typography><Typography variant="body1">3. Select{" "}<strong>Delete expired object delete markers or incomplete multipart uploads</strong>, then select{" "}<strong>Delete expired object delete markers</strong>.</Typography><Typography variant="body1">4. Choose <strong>Create rule</strong>.</Typography><Stack sx={{
          alignItems: "flex-end"
        }}><ButtonWithIcon variant="contained" text="Create Lifecycle Rule in AWS" icon="material-symbols-open-in-new" iconPosition="right" disabled={!bucketName} onClick={() => window.open(`${managementUrl}/lifecycle/create?${bucketQuery}`, "_blank")} /></Stack></Stack>}{(!section || section === "versioning") && <Stack sx={{
        gap: "8px"
      }}>{!section && <Typography variant="h4">2. Edit Bucket Versioning in AWS</Typography>}<Typography variant="body1">Select <strong>Enable</strong>, then choose{" "}<strong>Save changes</strong>.</Typography><Stack sx={{
          alignItems: "flex-end"
        }}><ButtonWithIcon variant="contained" text="Edit Bucket Versioning in AWS" icon="material-symbols-open-in-new" iconPosition="right" disabled={!bucketName} onClick={() => window.open(`https://s3.console.aws.amazon.com/s3/bucket/${encodeURIComponent(bucketName)}/property/versioning/edit?region=${encodeURIComponent(region)}&bucketType=general`, "_blank")} /></Stack></Stack>}{!section && <Stack sx={{
        gap: "8px"
      }}>{!section && <Typography variant="h4">3. Edit Bucket Policy in AWS</Typography>}<Typography variant="body1">Merge these statements into your bucket policy and choose{" "}<strong>Save changes</strong>.</Typography><VaultOwnBucketCopyableAllAccountsPolicy bucketName={bucketName} /><Stack sx={{
          alignItems: "flex-end"
        }}><VaultOwnBucketEditKeyPolicyButton bucketName={bucketName} region={region} /></Stack></Stack>}</Stack>;
    $[4] = accountId;
    $[5] = bucketName;
    $[6] = bucketQuery;
    $[7] = managementUrl;
    $[8] = method;
    $[9] = region;
    $[10] = section;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <Stack sx={t2}>{t3}{t4}</Stack>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};